import {
  Box,
  Card,
  CardBody,
  Checkbox,
  CircularProgress,
  Divider,
  Flex,
  Text,
} from '@chakra-ui/react';
import React, {useEffect} from 'react';
import { IconButton } from '@mui/material';
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { AssignmentOutlined, CropSquareOutlined } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faClipboard } from '@fortawesome/free-regular-svg-icons';
// import { faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';

const ProgressBar = ({ status, value }) => {
  switch (status) {
    case 'queued':
      return <IconButton sx={{ padding:0, "&:hover":{backgroundColor: "transparent"}}} >
        <CropSquareOutlined sx={{ padding:0, fontSize: 18, color: "#cdcdcd" }}/>
      </IconButton>;
    case 'in_progress':
      return <CircularProgress size="18px" value={value} />;
    case 'concluded':
      return <IconButton sx={{ padding:0, "&:hover":{backgroundColor: "transparent"}}} ><CheckCircleOutlinedIcon sx={{ padding:0, fontSize: 18, color: "#009652" }}/></IconButton>;
    default:
      return <IconButton sx={{ padding:0, "&:hover":{backgroundColor: "transparent"}}} >
        <CropSquareOutlined sx={{ padding:0, fontSize: 18, color: "#cdcdcd" }}/>
      </IconButton>;
  }
};
const PlannerStepProgess = ({ step, status, percentageComplete }) => {
  const { message, number } = step;
  return (
    <Flex
      alignItems={'baseline'}
      gap={1.5}
      paddingLeft={1}
      paddingY={0}
      paddingTop={0.5}
      mY={1}
      borderRadius={'4px'}
      alignContent={"center"}
    >
      <Box>
        <ProgressBar status={status} value={percentageComplete} />
      </Box>
      {/* d6f5e1 */}
      <Flex fontSize={'13.5px'} p={0} bg={status === 'concluded' ? '#e6f7ed' : ''} gap={0} width={"100%"} marginRight={"0%"} paddingY={0}>
        <Box fontWeight="regular" paddingLeft={"8px"} color={status === 'concluded' ? '#009652' : '#1D1D1D'} fontSize="13.5px" fontFamily="sans-serif">{`${number}`}</Box>
        <Box color={status === 'concluded' ? '#009652' : '#1D1D1D'}>.</Box>
        <Box fontWeight="regular" paddingX={1} color={status === 'concluded' ? '#009652' : '#1D1D1D'} fontSize="13.5px" fontFamily="sans-serif">{message}</Box>
      </Flex>
    </Flex>
  );
};
const Planner = ({ plannerMessage, myActionMessages }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  // const plannerbodyRef = React.useRef(null);

  // useEffect(() => {
  //   if (plannerbodyRef.current) {
  //     plannerbodyRef.current.scrollTop = plannerbodyRef.current.scrollHeight;
  //   }
  // }, [plannerMessage]);

  return (
    <Card
      variant={'outline'}
      overflowY="auto"
      size="lg"
      maxWidth="100%"
      maxH={'28vh'}
      // ref={plannerbodyRef}
      backgroundColor={"#f6faff"}
      data-scrollable="true"
    >
      <Flex
        px={0}
        // py={1}
        height={"40px"}
        onClick={() => setIsOpen((prevState) => !prevState)}
        cursor={'pointer'}
        alignItems={'center'}
        // justifyContent={"center"}
        gap={2}
        justifyContent={'space-between'}
        position="sticky" // Add sticky positioning
        top="0" // Ensure it sticks to the top of the container
        zIndex="1" // Set z-index to ensure it appears above other content
        bg="#f6faff"
        borderBottom="1px solid #E5E5E5"
        // maxH={'20%'}
      >
        <Flex gap={"4px"} position="sticky" alignItems={'space-between'} paddingLeft={'16px'} justifyContent={"flex-end"} height={"40px"}>
          <IconButton sx={{ padding:0, borderRadius: "0%", "&:hover":{backgroundColor: "transparent"} }}> 
              <AssignmentOutlined sx={{padding:0, fontSize: "20px", color: "#5d5d5d" }}/>
            </IconButton>
          <Text paddingLeft="2px" pt={"2px"} fontWeight="regular" color="#1d1d1d" fontSize="14px" fontFamily="sans-serif" alignSelf={"center"}>Planner</Text>
        </Flex>
        <IconButton sx={{ padding:0, fontSize: "24px", color: "#adadad", marginRight:"16px", "&:hover":{backgroundColor: "transparent"} }} >
          { isOpen ? <ExpandMoreIcon/> : <ExpandLessIcon/> }
        </IconButton>
      </Flex>
      <AnimatePresence>
      {isOpen && (
          <CardBody h={'30%'} paddingY={'16px'} paddingX={'16px'}>
            <Box paddingLeft={1} paddingBottom={2} fontWeight="regular" color="#333333" fontFamily="sans-serif" fontSize="14px">
              Sure, let me plan the steps.
            </Box>
            {plannerMessage?.planner_message.step.map((step) => {
              const myFinalStatus = myActionMessages?.find(
                (actionMessage) => actionMessage.stepNumber === step.number
              )?.status;
              const percentageComplete = myActionMessages?.find(
                (actionMessage) => actionMessage.stepNumber === step.number
              )?.percentage_complete;

              console.log('myFinalStatus', myFinalStatus);
              console.log('percentageComplete', percentageComplete);

              return (
                <Box marginBottom={1}>
                  <PlannerStepProgess
                    step={step}
                    key={step?.number}
                    status={myFinalStatus}
                    percentageComplete={percentageComplete}
                  />
                </Box>
              );
            })}
          </CardBody>
        // </motion.div>
      )}
      </AnimatePresence>
    </Card>
  );
};

export default Planner;
